import React from 'react';
import { ITranslateProps, translate } from '../../../mixins/translate';
import { PanelBody, PanelButtonLink, PanelHeading } from '../../elements';

interface IReportImageProps extends ITranslateProps {
    reportImage: string;
    reportImageTitle: string;
    reportImageExternalUrl?: string | undefined;
}

class ReportImageComponent extends React.Component<IReportImageProps, Record<string, unknown>> {
    constructor(props: IReportImageProps) {
        super(props);
    }

    public override render() {
        return (
            <div className="panel" id={this.props.reportImage}>
                <PanelHeading text={this.props.reportImageTitle} icon="fa fa-image">
                    {this.props.reportImageExternalUrl && (
                        <PanelButtonLink
                            onClick={() => this.openInWindow(this.props.reportImageExternalUrl!)}
                            small={true}
                            primary={false}
                            icon="fa fa-external-link"
                            text={this.props.t('survey.open2dViewer')}
                        />
                    )}
                </PanelHeading>
                <PanelBody whiteBackground={true}>
                    <img
                        loading="lazy"
                        src={`/api/assets/${this.props.reportImage}/download`}
                        className="img-responsive"
                        title={this.props.reportImageTitle}
                        style={{ imageOrientation: 'from-image', maxHeight: '600px' }}
                    />
                </PanelBody>
            </div>
        );
    }

    private openInWindow(url: string) {
        window.open(url, undefined, 'height=600,width=960,status=yes,resizable=yes,toolbar=no,menubar=no,location=no');
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ReportImage = translate()(ReportImageComponent);
